export const bankOptions = [
  {
    key: "Zenith Bank",
    text: "Zenith Bank",
    value: "057",
  },
  {
    key: "UBA",
    text: "UBA",
    value: "033",
    disabled: true,
  },
  {
    key: "ALAT by WEMA",
    text: "ALAT by WEMA",
    value: "035A",
    disabled: true,
  },
  {
    key: "Kuda Bank",
    text: "Kuda Bank",
    value: "50211",
  },
];
